/**
 * React Query Keys für Type-Safe Cache Management
 *
 * Hierarchische Query Keys ermöglichen präzise Cache-Invalidierung:
 * - queryKeys.assets.all → invalidiert ALLE Asset-Queries
 * - queryKeys.assets.detail('123') → invalidiert NUR Asset 123
 */

export const queryKeys = {
  // Assets
  assets: {
    all: ['assets'] as const,
    lists: () => [...queryKeys.assets.all, 'list'] as const,
    list: (workspaceId: string) =>
      [...queryKeys.assets.lists(), workspaceId] as const,
    details: () => [...queryKeys.assets.all, 'detail'] as const,
    detail: (assetId: string) =>
      [...queryKeys.assets.details(), assetId] as const,
  },

  // Image Editor Settings
  imageEditorSettings: {
    all: ['image-editor-settings'] as const,
    integrations: () => [...queryKeys.imageEditorSettings.all, 'integration'] as const,
    integration: (integrationId: string) =>
      [...queryKeys.imageEditorSettings.integrations(), integrationId] as const,
    channels: () => [...queryKeys.imageEditorSettings.all, 'channel'] as const,
    channel: (channelId: string) =>
      [...queryKeys.imageEditorSettings.channels(), channelId] as const,
  },

  // Processing Log
  processingLog: {
    all: ['processing-log'] as const,
    lists: () => [...queryKeys.processingLog.all, 'list'] as const,
    list: (workspaceId: string) =>
      [...queryKeys.processingLog.lists(), workspaceId] as const,
  },

  // Processing Status (Async Jobs)
  processingStatus: (taskId: string | null) =>
    ['processing-status', taskId] as const,
};
